import React from 'react'
import i18n from 'simple-react-i18n'
import ParameterCard from '../ParameterCard'
import PropTypes from 'prop-types'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import passwordPolicyHelp from 'assets/pictures/observatory/passwordPolicyHelp.webp'
import securityPasswordDescriptionHelp from 'assets/pictures/observatory/securityPasswordDescriptionHelp.webp'

const PasswordParameters = ({
    isGlobal = false,
    defaultProps = {},
}) => (
    <ParameterCard title={i18n.password} isGlobal={isGlobal}>
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='passwordPolicy'
            title={i18n.passwordRegex}
            helpImage={passwordPolicyHelp}
            placeholder='(?=(.*?[A-Z]){0,})(?=(.*?[0-9]){0,})(?=(.*?[^\w\s]){0,}).{6,}$'
        />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='securityPasswordDescription'
            title={i18n.passwordFormattingRules}
            helpImage={securityPasswordDescriptionHelp}
            placeholder={`${i18n.pleaseEnterAtLeastOneCapitalLetter}, ...`}
        />
    </ParameterCard>
)

PasswordParameters.propTypes = {
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default PasswordParameters
